import { del, get, post, put } from "../api"
import * as url from "./urls"

const getFlashAr = id => {
  const endpoint = url.GET_SHIPPING_EVENT_FLASH_AR.replace(":id", id)
  return get(endpoint)
}

const getFlashArPDF = id => {
  const endpoint = url.GET_SHIPPING_EVENT_FLASH_AR_PDF.replace(":id", id)
  return get(endpoint)
}

const getMobiAr = id => {
  const endpoint = url.GET_SHIPPING_EVENT_MOBI_AR.replace(":id", id)
  return get(endpoint)
}

const getInterLogAr = id => {
  const endpoint = url.GET_SHIPPING_EVENT_INTERLOG_AR.replace(":id", id)
  return get(endpoint)
}

const createShippingEvent = data => {
  return post(url.POST_SHIPPING_EVENT, data)
}

const deleteShippingEvent = id => {
  const endpoint = url.DELETE_SHIPPING_EVENT_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreShippingEvent = id => {
  const endpoint = url.RESTORE_SHIPPING_EVENT_BY_ID.replace(":id", id)
  return post(endpoint)
}

const getStatusSafra = () => {
  return get(url.GET_STATUS_SAFRA)
}

const getAllStatusSafra = () => {
  return get(url.GET_ALL_STATUS_SAFRA)
}

const deleteStatusSafra = id => {
  const endpoint = url.DELETE_STATUS_SAFRA_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreStatusSafra = id => {
  const endpoint = url.RESTORE_STATUS_SAFRA_BY_ID.replace(":id", id)
  return post(endpoint)
}

const createStatusSafra = data => {
  const { name, orderInTable } = data
  return post(url.POST_STATUS_SAFRA, { name, orderInTable })
}

const updateStatusSafra = (id, data) => {
  const endpoint = url.UPDATE_STATUS_SAFRA.replace(":id", id)
  const { name, orderInTable } = data
  return post(endpoint, { name, orderInTable })
}

const getStatus = () => {
  return get(url.GET_STATUS)
}

const getAllStatus = () => {
  return get(url.GET_ALL_STATUS)
}

const deleteStatus = id => {
  const endpoint = url.DELETE_STATUS_BY_ID.replace(":id", id)
  return del(endpoint)
}

const restoreStatus = id => {
  const endpoint = url.RESTORE_STATUS_BY_ID.replace(":id", id)
  return post(endpoint)
}

const createStatus = data => {
  const { name, isLast, statusSafraId, type } = data
  return post(url.POST_STATUS, {
    name,
    isLast,
    statusSafraId: statusSafraId?.value,
    type: type?.value,
  })
}

const updateStatus = (id, data) => {
  const endpoint = url.UPDATE_STATUS.replace(":id", id)
  const { name, isLast, statusSafraId, type } = data
  return post(endpoint, {
    name,
    isLast,
    statusSafraId: statusSafraId?.value,
    type: type?.value,
  })
}

const getDigitalAr = id => {
  return get(url.GET_DIGITAL_AR.replace(":id", id))
}

export {
  getFlashAr,
  getMobiAr,
  getInterLogAr,
  getFlashArPDF,
  createShippingEvent,
  deleteShippingEvent,
  restoreShippingEvent,
  getStatusSafra,
  getAllStatusSafra,
  deleteStatusSafra,
  restoreStatusSafra,
  createStatusSafra,
  updateStatusSafra,
  getStatus,
  getAllStatus,
  deleteStatus,
  restoreStatus,
  createStatus,
  updateStatus,
  getDigitalAr,
}
